import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Prompt } from 'react-router-dom';
import AppLocale from 'i18n';
import SettingsActions from 'store/reducers/Settings';

const BeforeOutAlert = React.memo( ( {
  locale, isActive, text, toggleLoading,
} ) => {
  useEffect( () => {
    const detectUnload = ( event ) => {
      if ( isActive ) {
        toggleLoading( false );
        // eslint-disable-next-line no-param-reassign
        event.returnValue = AppLocale[locale.locale][text] || text;
      }
    };
    window.addEventListener( 'beforeunload', detectUnload );

    return () => {
      window.removeEventListener( 'beforeunload', detectUnload );
    };
  }, [locale, isActive, text, toggleLoading] );

  return (
    <Prompt
      when={isActive}
      message={() => {
        const t = AppLocale[locale.locale][text] || text;
        return t;
      }}
    />
  );
} );

const mapStateToProps = ( { settings } ) => ( {
  locale: settings.locale,
} );
const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( mapStateToProps, mapDispatchToProps )( BeforeOutAlert );
